import { connectNetwork } from 'lib/NetworkProvider'
import View from 'lib/View'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { TOOLBAR_ACTIONS } from '../actions/toolbar'
import { Deposit } from '../components'

class SingleDeposit extends Component {
    constructor(props) {
        super(props)
        let { deposit } = this.props.match.params

        this.state = {
            deposit,
        }
    }

    componentDidUpdate() {}

    componentDidMount() {}

    render() {
        let { deposit } = this.state
        console.log('Loading deposit', deposit)
        return (
            <View column fullw fullh>
                <Deposit forcedOpen={true} showDetails={true} depositId={deposit} type="full" />
            </View>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        toolbarRequest: (result) => TOOLBAR_ACTIONS.request(result, dispatch),
        toolbarResult: (result) => TOOLBAR_ACTIONS.result(result, dispatch),
        toolbarError: (result) => TOOLBAR_ACTIONS.error(result, dispatch),
    }
}

const mapStateToProps = (state) => {
    return {}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(connectNetwork(SingleDeposit)))